import type * as models from 'pkg/api/models';
import type { Dateable } from 'pkg/api/models/dateable';
import type { Record } from 'pkg/api/models/record';

export interface AccountInvite extends Record, Dateable {
	id: number;
	accountId: number;
	authorId: number;
	groupId: number;
	created: number;
	used: boolean;
	key: string;
	email: string;
	message: string;
	languageCode: string;
	role: number;
	targets: AccountInviteTarget[];
}

export enum TargetType {
	Group = 'group',
	User = 'user',
	Account = 'account',
	Child = 'child',
	Unknown = 'unknown',
}

export interface AccountInviteTarget extends Record, Dateable {
	accountInviteId: number;
	type: TargetType;
	targetId: number;
	role: number;

	accountInvite?: AccountInvite;
	group?: models.group.Group;
	user?: models.user.User;
	child?: models.account.Account;
}
